import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsIceSkateNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M23.015 18.605l-1.18-1.45a2.264 2.264 0 00.815-1.735V14.3a2.533 2.533 0 00-1.68-2.38l-2.74-.98-6.18-3.32-.99-5.85A1.721 1.721 0 009.35.33h-1.3A1.733 1.733 0 006.4 1.51l-.93 2.82H3.38l.56-2.66H2.56L.84 9.89a26.1 26.1 0 00-.51 5.13 2.64 2.64 0 001.653 2.451l-1.242 2a2.753 2.753 0 002.336 4.208H20.6a3.11 3.11 0 002.411-5.07zM7.68 1.94a.387.387 0 01.37-.27h1.3a.387.387 0 01.38.33l.39 2.33H6.89zm-6 13.08c0-.96.06-1.918.18-2.87l5.23 2.81h2.85l-7.87-4.22c.03-.2.06-.39.1-.58l.93-4.49h7.25l.38 2.2v.01l-1.24 2.3 1.19.64 1-1.86 2.29 1.23-.99 1.86 1.19.64 1-1.87 2.3 1.24-1.01 1.87 1.19.64 1.08-2.02 1.79.64a1.187 1.187 0 01.78 1.11v1.12a.913.913 0 01-.91.91h-8.3l.01-.02H9.61l.03.02H2.98a1.312 1.312 0 01-1.3-1.31zm6 2.65h8.65v.166a1.49 1.49 0 01-1.489 1.49H9.164a1.491 1.491 0 01-1.489-1.49zm14.516 3.652a1.72 1.72 0 01-1.587 1H3.077a1.4 1.4 0 01-1.19-2.144l1.566-2.508h2.872v.166a2.843 2.843 0 002.84 2.84h5.671a2.843 2.843 0 002.84-2.84v-.166h2.714a.407.407 0 00.11-.01l1.468 1.8a1.724 1.724 0 01.223 1.862z"
        fill=""
      />
    </svg>
  )
);
SvgSportsIceSkateNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsIceSkateNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsIceSkateNormalSmall;
